import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import { Questionnaire } from "src/models";
import axios from '../axios';

export const getClientQuestionnaires = createAsyncThunk(
  'questionnaire/getClientQuestionnaires',
  async (_, { fulfillWithValue, rejectWithValue }) => {
    try {
      const { data } = await axios.get(`/user/kyc-questionnaires`);
      return fulfillWithValue(data.questionnaires);
    } catch (err) {
      const error = err as AxiosError;
      return rejectWithValue(error.response?.data);
    }
  }
);

export const getClientKYCFiles = createAsyncThunk(
  'questionnaire/getClientKYCFiles',
  async (client_uuid: string, { fulfillWithValue, rejectWithValue }) => {
    try {
      const { data } = await axios.get(`/user/kyc-files/client/${client_uuid}`);
      return fulfillWithValue(data.files);
    } catch (err) {
      const error = err as AxiosError;
      return rejectWithValue(error.response?.data);
    }
  }
);

export const getCountries = createAsyncThunk(
  'questionnaire/getCountries',
  async (_, { fulfillWithValue, rejectWithValue }) => {
    try {
      const { data } = await axios.get(`/user/config`);
      return fulfillWithValue(data.configurations);
    } catch (err) {
      const error = err as AxiosError;
      return rejectWithValue(error.response?.data);
    }
  }
);

export const getAgentBrand = createAsyncThunk(
  'questionnaire/getAgentBrand',
  async (agent_id: string, { fulfillWithValue, rejectWithValue }) => {
    try {
      const { data } = await axios.get(`/user/agency-brand/${agent_id}`);
      return fulfillWithValue(data.brand);
    } catch (err) {
      const error = err as AxiosError;
      return rejectWithValue(error.response?.data);
    }
  }
);

export const getMyProfile = createAsyncThunk(
  'questionnaire/getMyProfile',
  async (client_uuid: string, { fulfillWithValue, rejectWithValue }) => {
    try {
      const { data } = await axios.get(`/user/spa/client-profile/${client_uuid}`);
      return fulfillWithValue(data);
    } catch (err) {
      const error = err as AxiosError;
      return rejectWithValue(error.response?.data);
    }
  }
);

export const verifyToken = createAsyncThunk(
  'questionnaire/verifyToken',
  async (token: string, { fulfillWithValue, rejectWithValue }) => {
    try {
      const { data } = await axios.get(`/user/spa/verify-token/${token}`, { withCredentials: true });
      return fulfillWithValue(data);
    } catch (err) {
      const error = err as AxiosError;
      return rejectWithValue(error.response?.data);
    }
  }
);

export const securityCodeSetup = createAsyncThunk(
  'questionnaire/securityCodeSetup',
  async (security_code: string, { fulfillWithValue, rejectWithValue }) => {
    try {
      const { data } = await axios.post(`/user/spa/security-code`, { security_code }, { withCredentials: true });
      return fulfillWithValue(data);
    } catch (err) {
      const error = err as AxiosError;
      return rejectWithValue(error.response?.data);
    }
  }
);

export const reAuthenticate = createAsyncThunk(
  'questionnaire/reAuthenticate',
  async ({ security_code, client_uuid }: { security_code: string, client_uuid: string }, { fulfillWithValue, rejectWithValue }) => {
    try {
      const { data } = await axios.post(`/user/spa/security-code/re-auth`, { security_code, client_uuid });
      return fulfillWithValue(data);
    } catch (err) {
      const error = err as AxiosError;
      return rejectWithValue(error.response?.data);
    }
  }
);

export const getKYCSectionMatch = createAsyncThunk(
  'questionnaire/getKYCSectionMatch',
  async (_, { fulfillWithValue, rejectWithValue }) => {
    try {
      const { data } = await axios.get(`/questionnaire-title-match`);
      return fulfillWithValue(data.data);
    } catch (err) {
      const error = err as AxiosError;
      return rejectWithValue(error.response?.data);
    }
  }
);

export const getKYCSectionTitles = createAsyncThunk(
  'clients/getKYCSectionTitles',
  async (_, { fulfillWithValue, rejectWithValue }) => {
    try {
      const { data } = await axios.get('/user/kyc/section-titles');
      return fulfillWithValue(data.titles);
    } catch (err) {
      const error = err as AxiosError;
      return rejectWithValue(error.response?.data);
    }
  }
);

export const getKYCServicesTypes = createAsyncThunk(
  'config/getKYCServicesTypes',
  async (_, { fulfillWithValue, rejectWithValue }) => {
    try {
      const { data } = await axios.get('/kyc-service_types');
      return fulfillWithValue(data.services);
    } catch (err) {
      const error = err as AxiosError;
      return rejectWithValue(error.response?.data);
    }
  }
)

export const submitQuestionnaireAns = createAsyncThunk(
  'questionnaire/submitQuestionnaireAns',
  async ({ questionnaires, clientId, isDraft, files }: { questionnaires: Questionnaire[], clientId: string, isDraft: boolean, files: { [key: string]: File; } }, { fulfillWithValue, rejectWithValue }) => {
    try {
      const formData = new FormData();

      console.log('questionnaires: ', questionnaires);

      formData.append('questionnaire', JSON.stringify(questionnaires));
      formData.append('client_uuid', clientId);
      formData.append('is_draft', String(isDraft));

      if (files) {
        for (const key in files) {
          if (files.hasOwnProperty(key)) {
            formData.append(key, files[key]);
          }
        }
      }

      const { data } = await axios.put(`/user/kyc-questionnaires`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      return fulfillWithValue(data);
    } catch (err) {
      const error = err as AxiosError;
      return rejectWithValue(error.response?.data);
    }
  }
);
